export const createAutomationTask = /* GraphQL */ `
  mutation CreateAutomationTask(
    $input: CreateAutomationTaskInput!
    $condition: ModelAutomationTaskConditionInput
  ) {
    createAutomationTask(input: $input, condition: $condition) {
      id
      requirementConditions {
        type
        operator
        candidateStatus
        scoreScaled
        __typename
      }
      action {
        type
        campaignId
        candidateStatus
        atsRejectedReasonId
        atsInterviewStageId
        komboRejectionReasonId
        komboStageId
        __typename
      }
      candidateBatchId
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const updateAutomationTask = /* GraphQL */ `
  mutation UpdateAutomationTask(
    $input: UpdateAutomationTaskInput!
    $condition: ModelAutomationTaskConditionInput
  ) {
    updateAutomationTask(input: $input, condition: $condition) {
      id
      requirementConditions {
        type
        operator
        candidateStatus
        scoreScaled
        __typename
      }
      action {
        type
        campaignId
        candidateStatus
        atsRejectedReasonId
        atsInterviewStageId
        komboRejectionReasonId
        komboStageId
        __typename
      }
      candidateBatchId
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const deleteAutomationTask = /* GraphQL */ `
  mutation DeleteAutomationTask(
    $input: DeleteAutomationTaskInput!
    $condition: ModelAutomationTaskConditionInput
  ) {
    deleteAutomationTask(input: $input, condition: $condition) {
      id
      requirementConditions {
        type
        operator
        candidateStatus
        scoreScaled
        __typename
      }
      action {
        type
        campaignId
        candidateStatus
        atsRejectedReasonId
        atsInterviewStageId
        komboRejectionReasonId
        komboStageId
        __typename
      }
      candidateBatchId
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const automationTasksSaved = /* GraphQL */ `
  mutation AutomationTasksSaved($input: AutomationTasksSavedInput!) {
    automationTasksSaved(input: $input) {
      message
      __typename
    }
  }
`;

export const campaignAutomationTasksSaved = /* GraphQL */ `
  mutation CampaignAutomationTasksSaved(
    $input: CampaignAutomationTasksSavedInput!
  ) {
    campaignAutomationTasksSaved(input: $input) {
      message
      __typename
    }
  }
`;
